<div class="fullwidth-layout-container" basepage="secondary">
  <div class="row" #prodDetailTitle>
    <div class="col">
      <div class="page-nav-header no-pills">
        <div class="back-container" style="display: flex">
          <button type="button" class="btn btn-transparent p-0" (click)="goBack()" aria-label="back">
            <fa-icon icon="arrow-left" class="circle-icon-btn" aria-hidden="true"></fa-icon>
            <span class="sr-only">{{ "productDetail.back_sr_only" | translate }}</span>
          </button>
          @if (!snapshot && !missingFenderSerial) {
            <myp-skeleton-loader type="line" width="200px" height="30px"></myp-skeleton-loader>
          }
          <div>
            <fui-heading [text]="title" level="2"></fui-heading>
            @if (subTitle) {
              <span class="sub-title d-block">{{ subTitle }}</span>
            }
            @if (snapshot?.product?.version) {
              <span class="version" (click)="imageClick()">v{{ snapshot.product.version }}</span>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (loading) {
    <myp-skeleton-loader type="product-detail"></myp-skeleton-loader>
  }
  @if (!loading && missingFenderSerial) {
    <div class="row">
      <div class="col">
        <img style="max-width: 700px; max-height: 600px; margin: 0 auto; border-radius: 10px" [src]="missingFenderSerial.bodyImageUrl" />
        <div class="m-y-20 text-center">
          {{ "products.register.missing_fender_serial.thanks_entering_manual" | translate }}
        </div>
        <div class="text-center m-y-20">
          <span class="text-muted d-block">{{ "product_detail.serial_number" | translate }}</span>
          <span class="mono key t-20 bold brand-color">{{ displaySerialNumber | uppercase }}</span>
          <br />
          <br />
          <span class="small-btn red deregister" (click)="removeHardware(listProduct)">{{ "product_detail.deregister" | translate }}</span>
        </div>
      </div>
    </div>
  }

  @if (!loading && snapshot) {
    <div class="row">
      <div class="col-sm-3 col-lg-2 col-12" #prodDetailSidebar>
        <div #prodDetailSidebarSticky [class.sticky-sidebar]="shouldBeSticky" [ngStyle]="{ width: sidebarWidth + 'px' }">
          @if (mainImageUrl) {
            <div class="prod_img-container">
              <img class="prod_img" [src]="mainImageUrl" (click)="onMainImageClick()" />
            </div>
          }
          @if (galleryImages.length > 1) {
            <div class="prod-img-thumbs">
              @for (url of galleryImages; track url) {
                <img [src]="url" (click)="openGalleryAt(url)" />
              }
            </div>
          }
          @if (listProduct?.includedInSubscription) {
            <!-- <div class="d-flex t-12 align-items-center m-y-10">
            <img src="./assets/icons/plus-icon-blue.png" class="s1plus-icon-md m-r-5" alt="Studio One Plus icon" />
            <span class="serial-btn info">{{ "sphere.included_in_membership" | translate }}</span>
          </div>
          <div class="m-b-20" *ngIf="listProduct.releaseDate || listProduct.aquired">
            <span class="serial-btn info t-12">{{ "sphere.date_added" | translate }}: {{ listProduct.releaseDate || listProduct.aquired | date }}</span>
          </div> -->
          }
          @if (licenses) {
            <myp-installer-buttons
              [showAllSystems]="showAllSystems"
              [softwareDownloads]="snapshot.softwareDownloads"
              [downloadableContent]="snapshot.downloadableContent"
              [license]="licenses ? licenses[0] : null"
              [product]="snapshot.product"
              [showManageActivations]="(isS15 || isS16 || isS17) && listProduct?.includedInSubscription && !loadingLicenses"
            ></myp-installer-buttons>
          }
        </div>
      </div>
      <div class="col-12 col-lg-10 col-sm-9">
        <div class="prod_details">
          <div #prodDetailHead>
            @if (snapshot.product.stringId != "notion6.demo") {
              <div id="text_details">
                @if (productDescriptionHtml) {
                  <div #prodDescription class="description-wrapper m-b-10" [class.collapsed]="!descriptionExpanded" [class.overflowing]="descriptionOverflowing">
                    <div class="quill-content" [innerHTML]="productDescriptionHtml | safe: 'html'"></div>
                  </div>
                  @if (descriptionOverflowing) {
                    <button type="button" class="description-toggle m-b-10" (click)="toggleDescription()">
                      {{ descriptionExpanded ? "Show less" : "Show more" }}
                    </button>
                  }
                }
                @if (snapshot.product.stringId != "presonushub" && snapshot.product.partnerKey) {
                  <span class="sm b">
                    {{
                      (snapshot.product.stringId == "eastwest.composercloud"
                        ? "product_detail.redeem_code"
                        : snapshot.product.categoryId == "software"
                          ? "product_detail.product_keys"
                          : "product_detail.serial_numbers"
                      ) | translate
                    }}
                  </span>
                }
                @if (!productService.hasGottenProducts) {
                  <span class="font-italic">{{ "productDetail.loading_product_data" | translate }}</span>
                }
                @if (loadingLicenses) {
                  <div>
                    <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
                    {{ "productDetail.loading_licenses" | translate }}
                  </div>
                }
                @if (snapshot.missingFenderSerialData && !listProduct?.isMissingFenderSerial) {
                  <div class="detail_keys secondary-content-bg border-radius10 p-10">
                    <div>
                      <div>
                        <small class="text-muted d-block">{{ "product_detail.serial_number" | translate }}</small>
                        <span class="mono key">{{ displaySerialNumber | uppercase }}</span>
                      </div>
                    </div>
                  </div>
                }

                @if (listProduct?.isMissingFenderSerial && !missingFenderSerial) {
                  <!-- this is a missingFenderSerial with a sku entered. -->
                  <div class="detail_keys secondary-content-bg border-radius10 p-10">
                    <small class="text-muted d-block">{{ "product_detail.serial_number" | translate }}</small>
                    <span class="mono key">{{ listProduct.serial | uppercase }}</span>
                    <br />
                    <span class="unlock-key">{{ "productDetail.sku" | translate }} {{ listProduct.stringId }}</span>
                    <br />
                    <span class="small-btn red deregister" (click)="removeHardware(listProduct)">{{ "product_detail.deregister" | translate }}</span>
                  </div>
                }

                @for (license of licenses; track license) {
                  @if (license.productId == snapshot.product.id && license.categoryId != "subscription" && (license.showKey || showKeyActions)) {
                    <div class="detail_keys secondary-content-bg border-radius10 p-10">
                      @if (snapshot.product.partnerKey || license.showKey) {
                        <div>
                          @if (
                            snapshot.product.partnerName != "third_party" &&
                            snapshot.product.stringId != "notionmobile3" &&
                            snapshot.product.stringId != "fenderstudio1" &&
                            snapshot.product.stringId != "fendertone6"
                          ) {
                            <div>
                              <small class="text-muted d-block">{{ (license.productKeyString ? "product_detail.product_key" : "product_detail.serial_number") | translate }}</small>
                              <div class="d-flex align-items-center flex-wrap">
                                <span class="mono key">{{ license.productKeyString || license.hardwareSerialNumber | uppercase }}</span>
                                <button
                                  type="button"
                                  class="btn btn-primary btn-sm m-l-10"
                                  (click)="copyLicenseKey(license.productKeyString || license.hardwareSerialNumber, license)"
                                  aria-label="Copy"
                                >
                                  {{ copiedLicenseKeyId === license.licenseId + "" ? ("video.copied" | translate) : ("video.copy" | translate) }}
                                </button>
                              </div>
                            </div>
                          }
                          @if (snapshot.product.partnerName == "third_party") {
                            <div>
                              <small class="text-muted d-block">{{ (license.productKeyString ? "product_detail.product_key" : "product_detail.serial_number") | translate }}</small>
                              <div class="d-flex align-items-center flex-wrap">
                                <span class="mono key">{{ license.productKeyString || license.hardwareSerialNumber }}</span>
                                <button
                                  type="button"
                                  class="btn btn-primary btn-sm m-l-10"
                                  (click)="copyLicenseKey(license.productKeyString || license.hardwareSerialNumber, license)"
                                  aria-label="Copy"
                                >
                                  {{ copiedLicenseKeyId === license.licenseId + "" ? ("video.copied" | translate) : ("video.copy" | translate) }}
                                </button>
                              </div>
                              <br />
                              @if (license.productUnlockKey) {
                                <span class="unlock-key">{{ "product_detail.unlock_key" | translate }}: {{ license.productUnlockKey | uppercase }}</span>
                              }
                              <br />
                            </div>
                          }
                          @if (snapshot.pimSpecs && snapshot.product.fmic_material_number) {
                            <span class="unlock-key">
                              {{ "productDetail.sku" | translate }} {{ snapshot.product.fmic_material_number }}
                              <br />
                            </span>
                          }
                          @if (
                            license.productKeyOptionTitle && snapshot.product.stringId != "notionmobile3" && snapshot.product.stringId != "fenderstudio1" && snapshot.product.stringId != "fendertone6"
                          ) {
                            <span class="unlock-key">{{ "product_detail.vendor" | translate }}: {{ license.productKeyOptionTitle }}</span>
                          }
                        </div>
                      }
                      @if (showKeyActions) {
                        <div class="serial_actions">
                          @if (snapshot.product.stringId != "presonushub" && snapshot.product.categoryId != "subscription") {
                            <span class="serial-btn info">
                              {{ license.categoryId == "subscription" ? ("productDetail.renewed" | translate) : ("product_detail.registered" | translate) }}: {{ license.aquired | date }}
                            </span>
                          }
                          @if (license.expirationDate) {
                            <span class="serial-btn info">{{ "account.expiration_date" | translate }} {{ license.expirationDate | date }}</span>
                          }
                          @if (!license.upgraded && snapshot.product.canUpgrade && snapshot.product.stringId != "presonushub") {
                            <a class="small-btn blue" (click)="showUpgrade(license)">
                              {{ "general.upgrade" | translate }}
                            </a>
                          }
                          @if (
                            snapshot.product.categoryId != "hardware" &&
                            snapshot.product.licenseScheme == 0 &&
                            !snapshot.product.partnerName &&
                            snapshot.product.type != "bundle" &&
                            snapshot.product.stringId != "presonushub" &&
                            snapshot.product.stringId != "studiohub" &&
                            snapshot.product.categoryId != "subscription" &&
                            snapshot.product.stringId != "notionmobile3" &&
                            snapshot.product.stringId != "fenderstudio1" &&
                            snapshot.product.stringId != "fendertone6" &&
                            !snapshot.pimSpecs
                          ) {
                            <button
                              class="small-btn offline-activation offline-activation-btn"
                              tabindex="0"
                              (keyup.enter)="selectedLicense = license"
                              (click)="selectedLicense = license"
                              [ngbPopover]="popContent"
                              [popoverTitle]="popTitle"
                            >
                              {{ "product_detail.activations.offline_title" | translate }}
                            </button>
                          }
                          @if (license.transferable && +license.transferFee > 0) {
                            <button class="small-btn transfer" tabindex="0" (click)="showTransferLicense(license)">
                              {{ "product_detail.transfer_license.transfer_license" | translate }}
                            </button>
                          }
                          @if (
                            snapshot.product.categoryId != "subscription" && (snapshot.product.categoryId == "software" || (snapshot.product.categoryId == "extensions" && license.activations?.length))
                          ) {
                            @if (license.activations?.length && snapshot.product.licenseScheme != 1) {
                              <button class="small-btn manage" (click)="showManageActivations(license)">
                                {{ (license.activations?.length || 0) + "/" + license.maxActivations }} {{ "product_detail.activations.activations" | translate }} - {{ "general.manage" | translate }}
                              </button>
                            }
                            @if (!license.activations?.length) {
                              <span class="serial-btn info">
                                {{ (snapshot.product.stringId == "notion6" ? license.usedActivations : license.activations?.length) + "/" + license.maxActivations }}
                                {{ "product_detail.activations.activations" | translate }}
                              </span>
                            }
                          }
                          @if (snapshot.product.categoryId != "extension" && snapshot.product.categoryId != "software") {
                            <span class="small-btn red deregister" (click)="removeHardware(license)">{{ "product_detail.deregister" | translate }}</span>
                          }
                        </div>
                      }
                      @if (license.extendedSupportDate && license.extendedSupportDate != "NO_EXTENDED_SUPPORT") {
                        <div class="t-12">
                          <span>{{ "product_detail.eligible_for_all_updates" | translate: { date: (license.extendedSupportDate | date) } }}</span>
                          -
                          <a class="small-btn blue" (click)="showUpgrade(license)">{{ "product_detail.extend" | translate }}</a>
                        </div>
                      }
                      @if ((!license.extendedSupportDate || license.extendedSupportDate == "NO_EXTENDED_SUPPORT") && license.fallbackVersion) {
                        <div class="t-12">
                          <span>{{ "product_detail.eligibility_for_updates" | translate: { version: license.fallbackVersion } }}</span>
                          @if (license.fallbackVersion.split(".")[1] < productPointVersion && userService.subDetails?.subscription?.status != "active") {
                            <br />
                            {{ "productDetail.to_access_latest_version" | translate: { version: product.version } }}
                            <a href="javascript:void(0)" class="small-btn blue" (click)="showUpgrade(license)" style="margin: 0px">{{ "productDetail.upgrade_license" | translate }}</a>
                            {{ "productDetail.or" | translate }}
                            <a [routerLink]="['/account/plan']" style="margin: 0px">{{ "productDetail.resubscribe" | translate }}</a>
                            {{ "productDetail.to_studio_one_pro_plus" | translate }}
                          }
                          @if (userService.subDetails?.subscription?.status == "active") {
                            {{ "productDetail.unlimited_access_message" | translate }}
                          }
                          <a href="https://www.presonus.com/pages/studio-one-pro-faq" target="_blank">{{ "productDetail.learn_more" | translate }}</a>
                        </div>
                      }
                      @if (license.giveaways) {
                        @for (giveaway of license.giveaways; track giveaway) {
                          @if (!giveaway.allow_customer_claim && !giveaway.auto_gift && !giveaway.redeemed) {
                            <div class="t-14">
                              {{ "product_detail.comes_with_gift" | translate }} {{ giveaway.gift.title }}!&nbsp;&nbsp;
                              <button class="tiny-link red" (click)="learnMoreGiveaway(giveaway)">{{ "general.learn_more" | translate }}</button>
                            </div>
                          }
                        }
                      }
                    </div>
                  }
                }
              </div>
            }
          </div>

          @if (displayedPromotions?.length || discordGift.canClaimGift) {
            <div class="m-y-30">
              <h4 class="section-header m-b-10 m-t-30">{{ "newdash.special_offers" | translate }}</h4>
              <!-- A free copy leads; the paid Fender Studio Pro offer is filtered out of
                   `displayedPromotions` while this is showing. -->
              <fui-discord-free-fsp-offer headingSize="f6"></fui-discord-free-fsp-offer>
              @for (promo of displayedPromotions; track promo.id) {
                <div class="align-items-center m-b-20 offer-container">
                  @if (promo.offer_product?.product?.id == env.product_ids.sphere_monthly || promo.offer_product?.product?.id == env.product_ids.sphere_annual) {
                    <img src="./assets/images/fsp8-images/fsp-subscription-box.png" class="m-r-20 offer-image" style="max-width: 200px; display: inline-block" width="100%" alt="" />
                  } @else if (promo.offer_product?.product?.imageUrl) {
                    <img [src]="promo.offer_product.product.imageUrl" class="m-r-20 offer-image" style="max-width: 200px; display: inline-block" width="100%" alt="" />
                  }
                  <div class="offer-text">
                    <fui-heading
                      [text]="
                        (promo.coupon?.percent_off
                          ? promo.coupon.percent_off + '% off '
                          : promo.coupon?.amount_off
                            ? (promo.coupon.amount_off / 100 | currency: (promo.coupon.currency || 'usd').toUpperCase()) + ' off '
                            : 'Discount on ') +
                        (promo.offer_product?.product?.id == env.product_ids.sphere_monthly
                          ? 'Fender Studio Pro+ Monthly'
                          : promo.offer_product?.product?.id == env.product_ids.sphere_annual
                            ? 'Fender Studio Pro+ Annual'
                            : promo.offer_product?.product?.title || 'a product') +
                        '!'
                      "
                      level="3"
                      fontSize="f6"
                    ></fui-heading>
                    @if (listProduct?.isMissingFenderSerial) {
                      {{ "general.discount_offer_contact_advisor" | translate }}
                      <br />
                      <br />
                      <a class="btn btn-secondary" href="https://www.fender.com/pages/store-policies#erid45258197" target="_blank">{{ "general.contact_gear_advisor" | translate }}</a>
                    } @else {
                      {{ "general.discount_offer_simple" | translate }}
                      <br />
                      <br />
                      <button type="button" class="btn btn-primary" (click)="redeemPromotion(promo)">{{ "onboarding.join_now" | translate }}</button>
                    }
                  </div>
                </div>
              }
            </div>
          }

          @if (shouldShowFsAmpPackCallout) {
            <div class="d-flex align-items-center secondary-content-bg border-radius10 p-10 m-t-10">
              <img src="./assets/icons/fender-studio.png" style="width: 60px; height: 60px" alt="Fender Studio app icon" class="m-r-10" />
              <div>
                Thanks for registering! Your {{ listProduct?.title }} comes with a free complete Fender amp & FX pack in the Fender Studio app — a $49.99 value! Download the Fender Studio app to
                claim.
                <br />
                <a class="btn btn-secondary btn-sm m-t-10" href="https://www.fender.com/pages/fender-studio-app" target="_blank">{{ "general.learn_more" | translate }}</a>
              </div>
            </div>
          }

          @if (productService.studioOneStatus?.status == "can_redeem_fsp8") {
            <div class="m-y-30">
              <h4 class="section-header m-b-10 m-t-30">{{ "newdash.special_offers" | translate }}</h4>
              <div class="d-flex align-items-center">
                <img [src]="contentService.logos[appService.app][appService.activeTheme].dawBox" style="width: 150px" alt="Fender Studio Pro 8 icon" class="m-r-10" />
                <div>
                  <span>{{ "productDetail.eligible_studio_one_seven" | translate }}</span>
                  <br />
                  <br />
                  <button class="btn btn-primary" (click)="showFspRedeem()">{{ "productDetail.redeem_now" | translate }}</button>
                </div>
              </div>
            </div>
          }
          <!-- <div class="trans-bg p-20 border-radius10 d-inline-block m-y-20" *ngIf="productService.studioOneStatus?.status == 'can_redeem_fsp8'">
        <h4 class="t-14 bold">{{ "productDetail.eligible_studio_one_seven" | translate }}</h4>
        <button class="btn btn-primary" (click)="showFspRedeem()">{{ "productDetail.redeem_now" | translate }}</button>
      </div> -->
          @if (s1OrNotion || installMethods) {
            <div id="install_instructions" class="m-t-20 m-b-20">
              @if (s1OrNotion) {
                <h4 class="section-header m-b-10 m-t-30">
                  {{ "product_detail.install_instructions.to_install" | translate }}
                </h4>
                @if (snapshot.product.licenseScheme != 1) {
                  <span>{{ "product_detail.install_instructions.download_installer" | translate }}</span>
                }
                @if (snapshot.product.licenseScheme == 1) {
                  <span>{{ "product_detail.install_instructions.notion_download_installer" | translate }}</span>
                }
              }
              @if (installMethods) {
                @for (method of installMethods; track method) {
                  <div>
                    @if (method == "s1") {
                      <div class="m-t-20">
                        <span class="install_instructions_header">{{ "sphere.install_s1_title" | translate }}</span>
                        <br />
                        @if (snapshot.product.stringId == "presonus.fatchannel") {
                          <span>{{ "sphere.plugin_comes_s1" | translate }}</span>
                        }
                        @if (snapshot.product.stringId != "presonus.fatchannel") {
                          <span>{{ "sphere.download_plugin_installer" | translate }}</span>
                        }
                      </div>
                    }
                    @if (method == "hub") {
                      <div class="m-t-20">
                        <span class="install_instructions_header">{{ "sphere.install_in_hub" | translate }}</span>
                        <br />
                        {{ "sphere.download_hub_installer" | translate }}
                        <br />
                        <span class="btn btn-primary m-t-20" (click)="downloadHub()">
                          {{ productService.productsByStringIDs["presonushub"] ? ("download.download" | translate) : ("sphere.redeem_and_download" | translate) }} Fender Studio Hub
                        </span>
                      </div>
                    }
                    @if (method == "uc") {
                      <div class="m-t-20">
                        <span class="install_instructions_header">{{ "sphere.install_on_studiolive" | translate }}</span>
                        <br />
                        <span [innerHTML]="'sphere.first_download_uc' | translate"></span>
                        <br />
                        <a class="btn btn-primary" href="https://www.presonus.com/products/UC-Surface/downloads" target="_blank">{{ "sphere.download_uc" | translate }}</a>
                      </div>
                    }
                  </div>
                }
              }
            </div>
          }
          @if (hasExtrasOrOffers) {
            <h4 class="section-header m-b-10 m-t-30">
              {{ "productDetail.extras_and_offers" | translate }}
              <span class="section-header-link" (click)="extrasOffersCollapsed = !extrasOffersCollapsed">
                {{ extrasOffersCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                <fa-icon [icon]="extrasOffersCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
              </span>
            </h4>
            @if (!extrasOffersCollapsed) {
              <div>
                @for (license of licenses; track license) {
                  <div>
                    @if (license.offers && license.offers.length) {
                      <div class="trans-bg p-20 border-radius10 d-inline-block m-b-20">
                        <span class="t-14">{{ "newdash.you_are_elligible" | translate: { product: snapshot.product.title } }}</span>
                        <br />
                        <button class="btn btn-primary m-t-10" (click)="openOffers(license)">{{ "newdash.view_offers" | translate }}</button>
                      </div>
                    }
                  </div>
                }
                @if (productService.gettingProducts) {
                  <div class="m-y-10">
                    <myp-inline-loader [loading]="true" height="200px" spinnerName="gettingProductsLoader"></myp-inline-loader>
                  </div>
                }
              </div>
            }
          }
          @if (snapshot.pimSpecs) {
            <div class="m-t-20">
              <h4 class="section-header m-b-10 m-t-30">
                {{ "productDetail.specs" | translate }}
                <span class="section-header-link" (click)="specsCollapsed = !specsCollapsed">
                  {{ specsCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                  <fa-icon [icon]="specsCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                </span>
              </h4>
              @if (!specsCollapsed) {
                <div class="specs-container" [ngStyle]="{ 'max-height': showAllSpecs ? 'none' : '565px' }">
                  @for (spec of allSpecs; track spec) {
                    <div class="m-b-20">
                      <span class="t-16 brandfont-bold">
                        {{
                          ("productDetail.specSections." + spec.Name | translate) === "productDetail.specSections." + spec.Name ? spec.Name : ("productDetail.specSections." + spec.Name | translate)
                        }}
                      </span>
                      <div class="guitar-specs-table">
                        @for (item of spec | keyvalue; track item) {
                          @if (item.key.toString().toLowerCase() != "name" && item.key.toString().toLowerCase() != "country of origin" && item.key.toString().toLowerCase() != "sku display name") {
                            <div class="spec-row">
                              <span class="spec-key">
                                {{
                                  ("productDetail.specFields." + item.key.toString() | translate) === "productDetail.specFields." + item.key.toString()
                                    ? item.key
                                    : ("productDetail.specFields." + item.key.toString() | translate)
                                }}:
                              </span>
                              <span class="spec-value">{{ item.value }}</span>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  }
                </div>
                <button class="brand-btn-reverse sm m-t-20" (click)="showAllSpecs = !showAllSpecs">
                  {{ "productDetail.show" | translate }} {{ showAllSpecs ? ("productDetail.less" | translate) : ("productDetail.more" | translate) }}
                </button>
              }
            </div>
          }
          @if (crossSellBuckets?.length) {
            <div class="m-t-20">
              <h4 class="section-header m-b-10 m-t-30">
                You might also like
                <span class="section-header-link" (click)="crossSellCollapsed = !crossSellCollapsed">
                  {{ crossSellCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                  <fa-icon [icon]="crossSellCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                </span>
              </h4>
              @if (!crossSellCollapsed) {
                <ul class="nav nav-pills m-b-10">
                  @for (bucket of crossSellBuckets; track bucket) {
                    <li class="nav-item">
                      <a class="nav-link" tabindex="0" (keyup.enter)="displayCrossSellBucket(bucket)" (click)="displayCrossSellBucket(bucket)" [class.active]="bucket.displayed">
                        {{ bucket.type }}
                      </a>
                    </li>
                  }
                </ul>
                @if (displayedCrossSellBucket) {
                  <ul class="product-list-horizontal-scroll no-left-margin" preventHorizontalNav dragToScroll>
                    @for (prod of displayedCrossSellBucket.items; track prod) {
                      <li>
                        <myp-product-tile [product]="prod" [showDate]="false" [showStrippedDescription]="true" [buyNowUrl]="prod.shopUrl" (tileClicked)="openCrossSell(prod)"></myp-product-tile>
                      </li>
                    }
                  </ul>
                }
              }
            </div>
          }
          <div class="m-t-20">
            <myp-bundled-downloads [product]="snapshot.product" [downloadableContent]="snapshot.downloadableContent" [showAllSystems]="showAllSystems"></myp-bundled-downloads>
          </div>
        </div>
        <div>
          @if (bundledProducts && bundledProducts.length) {
            <div class="children">
              <h4 class="section-header m-b-10 m-t-30">
                {{ "product_detail.product_comes_with" | translate }}
                <span class="section-header-link" (click)="bundledProductsCollapsed = !bundledProductsCollapsed">
                  {{ bundledProductsCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                  <fa-icon [icon]="bundledProductsCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                </span>
              </h4>
              @if (!bundledProductsCollapsed) {
                <div class="grid-container pad-10">
                  @for (prod of bundledProducts; track prod) {
                    <myp-product-tile (tileClicked)="tileClick(prod)" [product]="prod"></myp-product-tile>
                  }
                </div>
              }
            </div>
          }
          @if (snapshot && downloads && downloadSections?.length) {
            <div class="product-downloads" id="product-downloads">
              <h4 class="section-header m-b-10 m-t-30">
                {{ "download.downloads" | translate }}
                <span class="section-header-link" (click)="downloadsCollapsed = !downloadsCollapsed">
                  {{ downloadsCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                  <fa-icon [icon]="downloadsCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                </span>
              </h4>
              @if (!downloadsCollapsed) {
                <div>
                  <myp-product-downloads #productDownloads [downloads]="downloads" [downloadSections]="downloadSections" [product]="snapshot.product"></myp-product-downloads>
                </div>
              }
            </div>
          }
          @if (snapshot && snapshot?.samples?.length) {
            <div class="product-downloads">
              <h4 class="section-header m-b-10 m-t-30">
                {{ "productDetail.sound_samples" | translate }}
                <span class="section-header-link" (click)="samplesCollapsed = !samplesCollapsed">
                  {{ samplesCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                  <fa-icon [icon]="samplesCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                </span>
              </h4>
              @if (!samplesCollapsed) {
                @for (smp of snapshot.samples; track smp) {
                  <myp-list-item
                    [item]="smp"
                    [title]="smp.title"
                    [icon]="'circle-play'"
                    [includeBottomBorder]="true"
                    [showBackground]="false"
                    [showImage]="false"
                    [includeChevron]="false"
                    (itemClicked)="playSample(smp)"
                  ></myp-list-item>
                }
                <!-- <div class="grid-container pad-10">
                  @for (smp of snapshot.samples; track smp) {
                    <div (click)="playSample(smp)" class="item-tile p-10">
                      <fa-icon icon="play-circle" class="t-20"></fa-icon>
                      <span class="brandfont-bold">{{ smp.title }}</span>
                    </div>
                  }
                </div> -->
              }
            </div>
          }
          @if (hasThirdPartyKeys) {
            <div class="third-party-keys">
              <h4 class="section-header m-t-30 m-b-20">{{ "product_detail.third_party_keys" | translate }}</h4>
              @for (item of licenses; track item) {
                <div class="m-y-30">
                  @for (key of item.oemItems; track key) {
                    <div>
                      <strong>{{ "product_detail.product_key" | translate }}: {{ item.productKeyString }}</strong>
                      @if (item.productKeyString) {
                        <button type="button" class="btn btn-primary btn-sm m-l-10" (click)="copyLicenseKey(item.productKeyString, item)" aria-label="Copy">
                          {{ copiedLicenseKeyId === item.licenseId + "" ? ("video.copied" | translate) : ("video.copy" | translate) }}
                        </button>
                      }
                      <br />
                      <span>
                        {{ key.title }} -
                        @if (!key.data && !key.loading) {
                          <span class="btn btn-primary btn-sm" (click)="getOemKey(item, key)">{{ "product_detail.claim_product_key" | translate }}</span>
                        }
                        @if (!key.loading && key.data) {
                          <span>{{ key.data }}</span>
                          <button type="button" class="btn btn-primary btn-sm m-l-10" (click)="copyThirdPartyKey(key.data, item, key)" aria-label="Copy">
                            {{ copiedThirdPartyKeyId === item.licenseId + ":" + key.stringId ? ("video.copied" | translate) : ("video.copy" | translate) }}
                          </button>
                        }
                        @if (key.loading) {
                          <span>{{ "product_detail.claiming_key" | translate }}</span>
                        }
                      </span>
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (resources && resourcesSections?.length) {
            <div class="product-downloads">
              <h4 class="section-header m-b-10 m-t-30">
                {{ "product_detail.product_resources" | translate }}
                <span class="section-header-link" (click)="resourcesCollapsed = !resourcesCollapsed">
                  {{ resourcesCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                  <fa-icon [icon]="resourcesCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                </span>
              </h4>
              @if (!resourcesCollapsed) {
                <div>
                  <ul class="nav nav-pills m-b-10">
                    @for (section of resourcesSections; track section) {
                      <li class="nav-item">
                        <a class="nav-link" (click)="displayResourceSection(section)" tabindex="0" (keyup.enter)="displayResourceSection(section)" [class.active]="section.displayed">
                          {{ (section.value == "lessons" ? "education.lessons" : "general." + section.value) | translate }}
                        </a>
                      </li>
                    }
                  </ul>
                  @if (displayedResourcesSection.value == "related_products") {
                    <div class="grid-container pad-10">
                      @for (prod of snapshot.relatedProducts; track prod) {
                        <myp-product-tile (tileClicked)="tileClick(prod)" [product]="prod"></myp-product-tile>
                      }
                    </div>
                  }
                  @if (displayedResourcesSection.value == "videos") {
                    <fui-video-rail [leftMargin]="false" [title]="'general.videos' | translate" [videos]="snapshot.videos" (showMoreVideos)="showMoreVideos()"></fui-video-rail>
                  }
                  @if (displayedResourcesSection.value == "lessons") {
                    <div class="m-t-10">
                      @for (lesson of snapshot.lessons; track lesson) {
                        <myp-learn-list-item [item]="lesson"></myp-learn-list-item>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (snapshot?.product?.extendable && licenses) {
            <div class="product-downloads row">
              <div class="col-md-12">
                <h4 class="section-header m-t-30 m-b-20">{{ "product_detail.option_cards.option_card" | translate }}</h4>
                @if (optionCards && optionCards.length) {
                  <div>
                    @for (card of optionCards; track card) {
                      <div class="option-card">
                        <img [src]="card.imageUrl" />
                        <div>
                          <span class="title">{{ card.title }}</span>
                          <br />
                          <span class="details">
                            {{ "general.serial_number" | translate }}: {{ card.hardwareSerialNumber }}
                            <br />
                            {{ "product_detail.option_cards.prod_with_sn" | translate }} {{ card.parentSerial | uppercase }}
                          </span>
                        </div>
                        <div class="buttons">
                          <span class="btn btn-primary btn-sm" (click)="optionCardInstructions(card)">{{ "product_detail.option_cards.view_install_instructions" | translate }}</span>
                          <span class="btn btn-danger btn-sm" (click)="deregisterOptionCard(card)">
                            {{ (removingOptionCard ? "product_detail.option_cards.removing" : "product_detail.option_cards.remove") | translate }}
                          </span>
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (!optionCards?.length) {
                  <span>{{ "product_detail.option_cards.no_option_cards" | translate }}</span>
                }
                <br />
                <br />
                <span class="btn btn-primary" (click)="addOptionCard()">{{ "product_detail.option_cards.register_option_card" | translate }}</span>
              </div>
            </div>
          }
          @if (highlights) {
            <div class="m-t-20">
              <h4 class="section-header m-b-10 m-t-30">
                {{ "productDetail.product_highlights" | translate }}
                <span class="section-header-link" (click)="highlightsCollapsed = !highlightsCollapsed">
                  {{ highlightsCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                  <fa-icon [icon]="highlightsCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                </span>
              </h4>
              @if (!highlightsCollapsed) {
                <div class="row">
                  @for (highlight of highlights; track highlight; let i = $index; let last = $last) {
                    <div class="col-md-6 col-lg-4 m-b-50">
                      <div class="d-flex justify-content-center">
                        <img [src]="highlight.url" class="w-full" style="border-radius: 10px; max-width: 250px" />
                      </div>
                      <div class="m-t-10">
                        <span class="t-18 brandfont-bold">{{ highlight.title }}</span>
                        <br />
                        <span class="t-14">{{ highlight.description }}</span>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
          <div class="m-b-50"></div>
        </div>
      </div>
    </div>
  }
</div>

<ng-template #popContent>
  @if (snapshot?.product?.categoryId == "software") {
    <button (keyup.enter)="showActivateOffline(selectedLicense)" (click)="showActivateOffline(selectedLicense)" class="activate_software_manual btn btn-primary btn-success">
      <span class="glyphicon glyphicon-plus-sign"></span>
      {{ "product_detail.activations.activate_software" | translate }}
    </button>
  }
  @if (snapshot?.product?.categoryId == "software" && selectedLicense.activations?.length > 0) {
    <button type="button" class="download_license btn btn-primary btn-primary" [disabled]="downloadingLicense" (click)="downloadLicense(true)">
      <span class="glyphicon glyphicon-download"></span>
      {{ "product_detail.activations.download_license" | translate }}
    </button>
  }
  @if (snapshot?.product?.categoryId == "extension" && snapshot?.product?.licenseScheme == 0 && !snapshot?.product?.partnerName) {
    <button type="button" class="download_license btn btn-primary btn-primary" [disabled]="downloadingLicense" (click)="downloadLicense(false)">
      <span class="glyphicon glyphicon-download"></span>
      {{ "product_detail.activations.download_license" | translate }}
    </button>
  }
</ng-template>
<ng-template #popTitle>
  <span style="color: #333">{{ "product_detail.activations.offline_title" | translate }}</span>
</ng-template>
